var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorContent"},[_c('img',{attrs:{"src":require("../../assets/img/500@2x.png")}}),_c('p',[_vm._v("哎哟～服务器居然累倒了...")]),_c('p',[_vm._v("别急，工程师正在紧急处理，马上就好")]),_c('router-link',{attrs:{"to":"/","tag":"a"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }